import { RefSoustypeUtilisateur } from './ref-soustype-utilisateur.model';
import { DroitFonctionnel } from './droit-fonctionnel.model';
import { ArrayClassConverterFactory } from '../../../core/services/mapper/data-property.converter';

export class ReferencesDroits {
    static jsonMap = {
        soustypesUtilisateurs: { key: 'refSousTypeDTOS', converter: new (ArrayClassConverterFactory.build(RefSoustypeUtilisateur))() },
        droitsFonctionnels: { key: 'refDroitFonctionnelDTOS', converter: new (ArrayClassConverterFactory.build(DroitFonctionnel))() }
    };

    soustypesUtilisateurs: RefSoustypeUtilisateur[];
    droitsFonctionnels: DroitFonctionnel[];
}
